import React, { useEffect, useState } from 'react';
import './classes/ConferenceSidebarBlocks.css';
import { configData } from "../config";

// Blocks the live site places in the sidebars of some conference and course pages, with their
// content typed into the block (Drupal custom blocks 133, 134, 11, 120, 14, 26 and 43). The pictures
// and the files to download are on the live site, which has every file.
const files_url = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/default/files/';

// Block 133: pictures of the Toronto PrimeTime conference
const PRIMETIME_PICTURES = [
    'PrimeTime Sports Management Conference.jfif',
    'PrimeTime Sports Management Conference 01.jfif',
    'PrimeTime Sports Management Conference 02.jfif',
    'PrimeTime Sports Management Conference 03.png',
    'PrimeTime Sports Management Conference 04.jfif',
    'PrimeTime Sports Management Conference 05.jfif',
    'PrimeTime Sports Management Conference 06.jfif',
];

// Block 134: pictures of the Race Track Business Conference
const RACETRACK_PICTURES = ['racetrack-right-1.jpg', 'racetrack-right-2.jpg', 'racetrack-right-3.jpg'];

// Block 11: what hockey executives say about SMWW
const HOCKEY_QUOTES = [
    {
        name: 'Brian Burke',
        roles: ['Calgary Flames GM'],
        picture: 'brain.png',
        quote: '"If you are thinking about a career in hockey, SMWW is a cutting edge program that offers you the training, skills, vital networking, mentoring, and hockey specific training that will assist you in breaking in or advancing your career in professional hockey. They have hundreds of graduates now working at all levels of the game."',
    },
    {
        name: 'Mike Johnston',
        roles: ['Portland Winterhawks GM/Head Coach', 'Former Pittsburgh Penguins Head Coach'],
        picture: 'mike.jpg',
        quote: '"SMWW is a quality organization. I personally have hired their graduates!"',
    },
    {
        name: 'EJ Hradek',
        roles: ['NHL Network'],
        picture: 'ej.jpg',
        quote: '"SMWW offers a tremendous opportunity for people to break into a career on the business side of hockey."',
    },
];

const PrimeTimePictures = () => (
    <div id="block-block-133" className="conference-sidebar-block">
        {PRIMETIME_PICTURES.map((file) => (
            <p key={file}><img src={files_url + encodeURIComponent(file)} alt="" /></p>
        ))}
    </div>
);

const RacetrackPictures = () => (
    <div id="block-block-134" className="conference-sidebar-block">
        {RACETRACK_PICTURES.map((file, idx) => (
            <React.Fragment key={file}>
                {idx > 0 && <div className="conference-sidebar-block__gap">&nbsp;</div>}
                <div><img src={files_url + file} alt="" /></div>
            </React.Fragment>
        ))}
    </div>
);

const HockeyQuotes = () => (
    <div id="block-block-11" className="conference-sidebar-block">
        {HOCKEY_QUOTES.map((person) => (
            <React.Fragment key={person.name}>
                <h2 className="conference-sidebar-block__title">
                    {person.name}<br />
                    {/* A second line of roles is smaller, inside a 15px line, as typed into the block */}
                    <span className={'conference-sidebar-block__roles' + (person.roles.length > 1 ? ' conference-sidebar-block__roles--two' : '')}>
                        {person.roles.map((role, idx) => (
                            <React.Fragment key={role}>
                                {idx > 0 && <br />}
                                <span className={idx > 0 ? 'conference-sidebar-block__role-small' : 'conference-sidebar-block__role'}>{role}</span>
                            </React.Fragment>
                        ))}
                    </span>
                </h2>
                <div className="conference-sidebar-block__quote">
                    <img src={files_url + person.picture} alt="" />
                    <p><em>{person.quote}</em></p>
                </div>
            </React.Fragment>
        ))}
    </div>
);

// Block 120: the NIL course's partner logo. Tablets and phones show only its empty box, as on the
// live site (the course body has its own copy there).
const NilPartnerLogo = () => (
    <div id="block-block-120" className="conference-sidebar-block">
        <div className="desktop_view_nil_logo">
            <p className="conference-sidebar-block__picture"><img src={files_url + 'n4a.png'} alt="" /></p>
            <p className="nil-partner-text">Proud Educational Partner of the National Association of NCAA Academic Advisors</p>
        </div>
    </div>
);

// Block 14: what sports broadcasting students and alumni have done
const BROADCASTING_STORY = [
    'The only radio work I was doing was a "great pretend job" in my car as I drove around. I had always wanted to do sports broadcasting. ESPN became a local station in my town here in South Carolina. I listened all 8 hours during my job. That\'s when I heard the SMWW commercial. I thought about it, but told myself I didn\'t have the time, nor the money. Well, a few months later I heard the ad again. I looked up the website on the computer and liked what I read.',
    'I signed up and received my material a week or two before classes started. I loved the exercises assigned by the instructors and the materials. I called my local show host to do my work study portion of the course and worked with them on my project. This really made me feel that I could be a sports radio show host!',
    'I called several stations trying to get some air time. Nobody was interested. But I didn\'t give up.',
    'Well, about this time a sales man at the station 100.1 The Fan got an opportunity to do a trial show. I emailed them an explained that I had received SMWW Sports Broadcasting training and just wanted to sit in on the show a couple of times. From my training at SMWW, they were impressed, and asked the production manager if I go on the air the next week. I then went on from guest hosting on Tuesdays, to Tuesdays and Thursdays! The show is, "The Open Mike" with Mike and Lee, and I am the guest host Mic\'T.',
    'Recently I have gone out on my own, and I am the sole proprietor of "Onda Ball Sportz". Thanks to the training at SMWW, I have just worked out my advertisement agreements, and developed a show format. I have negotiated and am in the progress of broadcasting my own show "Bleecher Talk". It will be simulcast on two am stations in two separate towns. Once the show get\'s going, I will do daily or bi-weekly sports updates for the station.',
    'Thanks to my training at SMWW, I am negotiating with a local business to back a local high school and I will broadcast their football games.',
    'Thanks to SMWW, I have my own radio show and I have successfully started my sports broadcasting career!',
];

const BroadcastingStories = () => (
    <div id="block-block-14" className="conference-sidebar-block">
        <h2 className="conference-sidebar-block__title">SMWW Student Interviews Erin Andrews at ESPN College Game Day</h2>
        <p className="conference-sidebar-block__picture">
            <img src={files_url + 'uploads/' + encodeURIComponent('Erin Andrews ESPN College Game Day SMWW.jpg')} width="170" alt="" />
        </p>
        <h2 className="conference-sidebar-block__title">SMWW Alumni Andy Tuitele with NFL Color Commentator John Madden</h2>
        <p className="conference-sidebar-block__picture">
            <img src={files_url + 'uploads/' + encodeURIComponent('John Madden with SMWW Student.jpg')} width="167" alt="" />
        </p>
        <h2 className="conference-sidebar-block__title">Another Sports Broadcasting Success Story From Michael Lloyd, SMWW Alumni:</h2>
        <p className="broadcasting-story">
            <em>
                <b>Dear Potential Sports Broadcasting Student:</b>
                {BROADCASTING_STORY.map((line) => (
                    <React.Fragment key={line}><br />{line}</React.Fragment>
                ))}
            </em>
        </p>
    </div>
);

// Block 26: the Must Love Baseball banner, in the left column under the mentors
const MustLoveBaseball = () => (
    <div id="block-block-26" className="conference-sidebar-block">
        <p className="conference-sidebar-block__picture">
            <a href="http://mustlovebaseball.com" target="_blank" rel="noreferrer"><img src={files_url + 'must-love-baseball.jpg'} alt="" /></a>
        </p>
    </div>
);

// A video in a popup over the page, as the live site opens block 43's YouTube link (colorbox,
// 640x390 inside the window)
const VideoPopup = ({ src, onClose }) => {
    useEffect(() => {
        const onKey = (event) => { if (event.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);
    return (
        <div className="conference-video-popup" onClick={onClose} role="dialog" aria-modal="true">
            <div className="conference-video-popup__frame" onClick={(event) => event.stopPropagation()}>
                <iframe src={src} title="Video" allow="autoplay; fullscreen" allowFullScreen frameBorder="0" />
                <button type="button" className="conference-video-popup__close" onClick={onClose} aria-label="Close">close</button>
            </div>
        </div>
    );
};

// Block 43: the London conference's video, registration box, NFL game tickets and the 2016 program
// to download, at the bottom of the right column
const LONDON_VIDEO = 'https://www.youtube.com/embed/i6Sg_VhF_ic?rel=0&autoplay=1';
const emptyLines = (count) => Array.from({ length: count }, (_, idx) => <div key={idx}>&nbsp;</div>);

const LondonConference = () => {
    const [video, setVideo] = useState(false);
    const openVideo = (event) => { event.preventDefault(); setVideo(true); };
    return (
        <div id="block-block-43" className="conference-sidebar-block london-conference-block">
            <div className="london-conference-block__box">
                <p><img src={files_url + 'conference-logo-image.gif'} style={{ width: '100%' }} alt="" /></p>
                <p><a className="youtube" href={LONDON_VIDEO} onClick={openVideo}><img src={files_url + 'london-utube-img.jpg'} style={{ width: '100%' }} alt="" /></a></p>
                <p>If you're looking to work in the business of International&nbsp;Sports, then you can't miss our annual Sports Career Conference in London. You'll learn how to break into the business <em>and&nbsp;</em>you can attend an NFL Football game while you're there!</p>
            </div>
            <div className="london-conference-block__button">
                <a className="reddbtnn" href="https://pay.smww.com/event/2017-nfl-london-sports-career-conference">Register Now &gt;&gt;</a>
            </div>
            <div className="london-conference-block__box london-conference-block__box--blue">
                <div>
                    <p><span style={{ color: '#FFFFFF' }}><span style={{ fontSize: '14px' }}><strong><span style={{ fontFamily: 'lucida sans unicode,lucida grande,sans-serif' }}>Conference Registration Includes:&nbsp;</span></strong></span></span></p>
                    <p><span style={{ color: '#FFFFFF' }}>♦ Delegate Badge &amp; Credentials<br />
                    ♦ Registration Packet<br />
                    ♦ All Conference Sessions<br />
                    ♦ NFL Game Tickets Available (For An Additional Fee)</span></p>
                </div>
            </div>
            {emptyLines(3)}
            <div className="rtecenter"><img src={files_url + 'Untitled.png'} style={{ width: '150px' }} alt="" /></div>
            <div className="rtecenter">&nbsp;</div>
            <div className="london-conference-block__box">
                <div>&nbsp;</div>
                <p><span style={{ fontSize: '20px' }}><strong>Tickets to the </strong></span><br />
                <span style={{ fontSize: '20px' }}><strong>NFL London Game</strong></span></p>
                <p>Join us at the game on&nbsp;Sunday, 1 October, and watch the<strong>&nbsp;New Orleans Saints vs Miami Dolphins</strong>. Seats are located in the Lower Level End Zone. Register first and then buy up to two game tickets per registration.</p>
                <p className="rtecenter"><a href="https://pay.smww.com/event/2017-nfl-london-game-dolphins-vs-saints"><img src={files_url + 'buytickets1.png'} style={{ width: '200px' }} alt="" /></a></p>
                <div className="rtecenter">&nbsp;</div>
                <div className="rtecenter"><img src={files_url + 'nfl-london.png'} style={{ width: '100%' }} alt="" /></div>
            </div>
            {emptyLines(3)}
            <p>&nbsp;</p>
            <div>&nbsp;</div>
            <p><strong>Download a Copy of the<br />
            2016 London Sports Program Here</strong></p>
            <p><strong><a href={files_url + '2016_London_program_online.pdf'} target="_blank" rel="noreferrer"><img src={files_url + '2015wembleyagenda.png'} style={{ width: '100%' }} alt="" /></a></strong></p>
            {emptyLines(9)}
            <div className="london-conference-block__end">&nbsp;</div>
            {video && <VideoPopup src={LONDON_VIDEO} onClose={() => setVideo(false)} />}
        </div>
    );
};

// Which page shows which block, and where: "top" under the quick form (at the top of the column),
// "middle" between the success stories and the testimonials, "bottom" under the testimonials,
// "left" in the left column between the mentors and the course's quick form
const BLOCKS = {
    893: { position: 'top', Block: PrimeTimePictures },     // /conferences/prime-time-sports-entertainment-conference
    98261: { position: 'top', Block: RacetrackPictures },   // /race-track-business-conference
    887: { position: 'middle', Block: HockeyQuotes },       // /conferences/nhl-draft-sports-career-conference
    889: { position: 'bottom', Block: LondonConference },   // /conferences/london-sports-career-conference-wembley
    217237: { position: 'top', Block: NilPartnerLogo },     // /courses/name-image-likeness
    513: { position: 'middle', Block: HockeyQuotes },       // /courses/hockey-gm-scouting
    519: { position: 'middle', Block: BroadcastingStories }, // /courses/sports-broadcasting
    506: { position: 'left', Block: MustLoveBaseball },     // /courses/baseball-gm-scouting
};

const ConferenceSidebarBlocks = ({ page, position }) => {
    const placed = BLOCKS[Number(page?.nid)];
    if (!placed || placed.position !== position) return null;
    return <placed.Block />;
};

export default ConferenceSidebarBlocks;
